import { Eye, EyeOff } from "lucide-react";

type Props = {
  shown: boolean;
  onToggle: () => void;
};

/** Show/hide button for `AuthField`'s `rightElement` slot. */
export function PasswordVisibilityToggle({ shown, onToggle }: Props) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={shown ? "Hide password" : "Show password"}
      aria-pressed={shown}
      className="absolute inset-y-0 right-0 flex w-12 items-center justify-center rounded-control text-ink-faint transition-colors hover:text-ink focus-visible:outline-offset-[-4px]"
    >
      {shown ? (
        <EyeOff className="size-4.5" strokeWidth={1.75} aria-hidden="true" />
      ) : (
        <Eye className="size-4.5" strokeWidth={1.75} aria-hidden="true" />
      )}
    </button>
  );
}
